var exports = {
  "iE": "x234b8571--7a266b--wrapper",
  "wx": "x234b8571--7a266b--header",
  "Qs": "x234b8571--7a266b--content",
  "qr": "x234b8571--7a266b--footer",
};

module.exports = exports;
